function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 82 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "17.5",
  y: "3.5",
  width: "19",
  height: "19",
  rx: "3.5",
  fill: "#FAFAFA",
  stroke: "#D2D6DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.8 8.96a.828.828 0 011.147-.057c.333.292.36.792.059 1.116l-6.096 6.573a.828.828 0 01-1.187.02l-3.317-3.34a.776.776 0 01.02-1.118.829.829 0 011.149.02l2.711 2.73L31.8 8.96z",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "41",
  y: "12",
  width: "24",
  height: "3",
  rx: "1",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "17.5",
  y: "27.5",
  width: "19",
  height: "19",
  rx: "3.5",
  fill: "#FAFAFA",
  stroke: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "41",
  y: "36",
  width: "24",
  height: "3",
  rx: "1",
  fill: "#D2D6DB"
})));